// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tauros: PokeData = {
  "id": 128,
  "name": "tauros",
  "height": 14,
  "weight": 884,
  "base_experience": 172,
  "types": [
    PokeType.NORMAL
  ],
  "api_moves": [
    "stomp",
    "horn-attack",
    "tackle",
    "take-down",
    "thrash",
    "double-edge",
    "tail-whip",
    "leer",
    "rage",
    "focus-energy",
    "rest",
    "scary-face",
    "outrage",
    "swagger",
    "pursuit",
    "payback",
    "assurance",
    "giga-impact",
    "zen-headbutt",
    "work-up",
    "raging-bull"
  ],
  "moves": [
    "tackle",
    "leer",
    "scary-face",
    "outrage",
    "pursuit",
    "zen-headbutt",
    "splash",
    "growl",
    "purification",
    "protect",
    "refresh",
    "scratch",
    "headbutt"
  ],
  "evolution_chain": {
    "id": 63,
    "item": null,
    "species": [
      {
        "name": "tauros",
        "order": 152,
        "types": [
          PokeType.NORMAL
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 109,
    "speed": 152,
    "ability_power": 139
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
